import { useShow } from '@refinedev/core'
import {
  Show,
  TextFieldComponent as TextField,
  EmailField,
} from '@refinedev/mui'
import { Typography, Stack } from '@mui/material'
import { RouteGuard } from '../../components/RouteGuard'
import { UserOrganisationsList } from '../../components/UserOrganisationsList'

export const UsersShow = () => {
  const { query } = useShow()
  const { data, isLoading } = query

  const record = data?.data

  return (
    <Show isLoading={isLoading}>
      <Stack gap={1}>
        <Typography variant="body1" fontWeight="bold">
          First Name
        </Typography>
        <TextField value={record?.first_name} />
        <Typography variant="body1" fontWeight="bold">
          Last Name
        </Typography>
        <TextField value={record?.last_name} />
        <Typography variant="body1" fontWeight="bold">
          Email
        </Typography>
        <EmailField value={record?.email} />
        <Typography variant="body1" fontWeight="bold">
          Role
        </Typography>
        <EmailField value={record?.role} />
        <Typography variant="body1" fontWeight="bold">
          Login Method
        </Typography>
        <Typography variant="body2">
          {record?.auth0_id?.startsWith('auth0|')
            ? 'Email and Password'
            : 'Google Account'}
        </Typography>
        <Typography variant="body1" fontWeight="bold">
          Account Linked
        </Typography>
        <Typography variant="body2">
          {record?.identities?.length > 1
            ? 'Yes — can log in with both Email/Password and Google'
            : 'No — single login method only'}
        </Typography>

        <Typography variant="body1" fontWeight="bold" sx={{ mt: 3 }}>
          Organisations
        </Typography>
        <RouteGuard allowedPermissions={['Full', 'Orgs Users']}>
          <UserOrganisationsList userId={record?.uuid} />
        </RouteGuard>
      </Stack>
    </Show>
  )
}
